import { translate, TranslatorContext } from 'react-jhipster';

// Simple direct access to translate function
export const useTranslation = () => {
  return {
    t: (key: string, ...args: any[]) => translate(key, ...args)
  };
};

// Access all translation utilities
export const useFullTranslation = () => {
  return {
    t: (key: string, ...args: any[]) => translate(key, ...args),
    translate,
    context: TranslatorContext
  };
};
